export default [
	{
		login: 'adcor',
		id: 8251517,
		node_id: 'MDQ6VXNlcjgyNTE1MTc=',
		avatar_url: 'https://avatars0.githubusercontent.com/u/8251517?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/adcor',
		html_url: 'https://github.com/adcor',
		followers_url: 'https://api.github.com/users/adcor/followers',
		following_url: 'https://api.github.com/users/adcor/following{/other_user}',
		gists_url: 'https://api.github.com/users/adcor/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/adcor/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/adcor/subscriptions',
		organizations_url: 'https://api.github.com/users/adcor/orgs',
		repos_url: 'https://api.github.com/users/adcor/repos',
		events_url: 'https://api.github.com/users/adcor/events{/privacy}',
		received_events_url: 'https://api.github.com/users/adcor/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'pogiako35',
		id: 28615313,
		node_id: 'MDQ6VXNlcjI4NjE1MzEz',
		avatar_url: 'https://avatars2.githubusercontent.com/u/28615313?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/pogiako35',
		html_url: 'https://github.com/pogiako35',
		followers_url: 'https://api.github.com/users/pogiako35/followers',
		following_url:
			'https://api.github.com/users/pogiako35/following{/other_user}',
		gists_url: 'https://api.github.com/users/pogiako35/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/pogiako35/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/pogiako35/subscriptions',
		organizations_url: 'https://api.github.com/users/pogiako35/orgs',
		repos_url: 'https://api.github.com/users/pogiako35/repos',
		events_url: 'https://api.github.com/users/pogiako35/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/pogiako35/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'JonDevOps',
		id: 30133774,
		node_id: 'MDQ6VXNlcjMwMTMzNzc0',
		avatar_url: 'https://avatars2.githubusercontent.com/u/30133774?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/JonDevOps',
		html_url: 'https://github.com/JonDevOps',
		followers_url: 'https://api.github.com/users/JonDevOps/followers',
		following_url:
			'https://api.github.com/users/JonDevOps/following{/other_user}',
		gists_url: 'https://api.github.com/users/JonDevOps/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/JonDevOps/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/JonDevOps/subscriptions',
		organizations_url: 'https://api.github.com/users/JonDevOps/orgs',
		repos_url: 'https://api.github.com/users/JonDevOps/repos',
		events_url: 'https://api.github.com/users/JonDevOps/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/JonDevOps/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'danielbyun',
		id: 23326866,
		node_id: 'MDQ6VXNlcjIzMzI2ODY2',
		avatar_url: 'https://avatars2.githubusercontent.com/u/23326866?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/danielbyun',
		html_url: 'https://github.com/danielbyun',
		followers_url: 'https://api.github.com/users/danielbyun/followers',
		following_url:
			'https://api.github.com/users/danielbyun/following{/other_user}',
		gists_url: 'https://api.github.com/users/danielbyun/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/danielbyun/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/danielbyun/subscriptions',
		organizations_url: 'https://api.github.com/users/danielbyun/orgs',
		repos_url: 'https://api.github.com/users/danielbyun/repos',
		events_url: 'https://api.github.com/users/danielbyun/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/danielbyun/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'GabeAboy',
		id: 8711066,
		node_id: 'MDQ6VXNlcjg3MTEwNjY=',
		avatar_url: 'https://avatars3.githubusercontent.com/u/8711066?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/GabeAboy',
		html_url: 'https://github.com/GabeAboy',
		followers_url: 'https://api.github.com/users/GabeAboy/followers',
		following_url:
			'https://api.github.com/users/GabeAboy/following{/other_user}',
		gists_url: 'https://api.github.com/users/GabeAboy/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/GabeAboy/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/GabeAboy/subscriptions',
		organizations_url: 'https://api.github.com/users/GabeAboy/orgs',
		repos_url: 'https://api.github.com/users/GabeAboy/repos',
		events_url: 'https://api.github.com/users/GabeAboy/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/GabeAboy/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'fajarkeren123',
		id: 37859542,
		node_id: 'MDQ6VXNlcjM3ODU5NTQy',
		avatar_url: 'https://avatars2.githubusercontent.com/u/37859542?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/fajarkeren123',
		html_url: 'https://github.com/fajarkeren123',
		followers_url: 'https://api.github.com/users/fajarkeren123/followers',
		following_url:
			'https://api.github.com/users/fajarkeren123/following{/other_user}',
		gists_url: 'https://api.github.com/users/fajarkeren123/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/fajarkeren123/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/fajarkeren123/subscriptions',
		organizations_url: 'https://api.github.com/users/fajarkeren123/orgs',
		repos_url: 'https://api.github.com/users/fajarkeren123/repos',
		events_url: 'https://api.github.com/users/fajarkeren123/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/fajarkeren123/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'ana-vela',
		id: 20852847,
		node_id: 'MDQ6VXNlcjIwODUyODQ3',
		avatar_url: 'https://avatars0.githubusercontent.com/u/20852847?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/ana-vela',
		html_url: 'https://github.com/ana-vela',
		followers_url: 'https://api.github.com/users/ana-vela/followers',
		following_url:
			'https://api.github.com/users/ana-vela/following{/other_user}',
		gists_url: 'https://api.github.com/users/ana-vela/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/ana-vela/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/ana-vela/subscriptions',
		organizations_url: 'https://api.github.com/users/ana-vela/orgs',
		repos_url: 'https://api.github.com/users/ana-vela/repos',
		events_url: 'https://api.github.com/users/ana-vela/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/ana-vela/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'strongdan',
		id: 3577434,
		node_id: 'MDQ6VXNlcjM1Nzc0MzQ=',
		avatar_url: 'https://avatars3.githubusercontent.com/u/3577434?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/strongdan',
		html_url: 'https://github.com/strongdan',
		followers_url: 'https://api.github.com/users/strongdan/followers',
		following_url:
			'https://api.github.com/users/strongdan/following{/other_user}',
		gists_url: 'https://api.github.com/users/strongdan/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/strongdan/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/strongdan/subscriptions',
		organizations_url: 'https://api.github.com/users/strongdan/orgs',
		repos_url: 'https://api.github.com/users/strongdan/repos',
		events_url: 'https://api.github.com/users/strongdan/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/strongdan/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: '77ccreed',
		id: 32397184,
		node_id: 'MDQ6VXNlcjMyMzk3MTg0',
		avatar_url: 'https://avatars1.githubusercontent.com/u/32397184?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/77ccreed',
		html_url: 'https://github.com/77ccreed',
		followers_url: 'https://api.github.com/users/77ccreed/followers',
		following_url:
			'https://api.github.com/users/77ccreed/following{/other_user}',
		gists_url: 'https://api.github.com/users/77ccreed/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/77ccreed/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/77ccreed/subscriptions',
		organizations_url: 'https://api.github.com/users/77ccreed/orgs',
		repos_url: 'https://api.github.com/users/77ccreed/repos',
		events_url: 'https://api.github.com/users/77ccreed/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/77ccreed/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'imatari',
		id: 19500800,
		node_id: 'MDQ6VXNlcjE5NTAwODAw',
		avatar_url: 'https://avatars1.githubusercontent.com/u/19500800?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/imatari',
		html_url: 'https://github.com/imatari',
		followers_url: 'https://api.github.com/users/imatari/followers',
		following_url:
			'https://api.github.com/users/imatari/following{/other_user}',
		gists_url: 'https://api.github.com/users/imatari/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/imatari/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/imatari/subscriptions',
		organizations_url: 'https://api.github.com/users/imatari/orgs',
		repos_url: 'https://api.github.com/users/imatari/repos',
		events_url: 'https://api.github.com/users/imatari/events{/privacy}',
		received_events_url: 'https://api.github.com/users/imatari/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'carteron888',
		id: 40364331,
		node_id: 'MDQ6VXNlcjQwMzY0MzMx',
		avatar_url: 'https://avatars3.githubusercontent.com/u/40364331?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/carteron888',
		html_url: 'https://github.com/carteron888',
		followers_url: 'https://api.github.com/users/carteron888/followers',
		following_url:
			'https://api.github.com/users/carteron888/following{/other_user}',
		gists_url: 'https://api.github.com/users/carteron888/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/carteron888/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/carteron888/subscriptions',
		organizations_url: 'https://api.github.com/users/carteron888/orgs',
		repos_url: 'https://api.github.com/users/carteron888/repos',
		events_url: 'https://api.github.com/users/carteron888/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/carteron888/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'albertfougy',
		id: 17938053,
		node_id: 'MDQ6VXNlcjE3OTM4MDUz',
		avatar_url: 'https://avatars1.githubusercontent.com/u/17938053?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/albertfougy',
		html_url: 'https://github.com/albertfougy',
		followers_url: 'https://api.github.com/users/albertfougy/followers',
		following_url:
			'https://api.github.com/users/albertfougy/following{/other_user}',
		gists_url: 'https://api.github.com/users/albertfougy/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/albertfougy/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/albertfougy/subscriptions',
		organizations_url: 'https://api.github.com/users/albertfougy/orgs',
		repos_url: 'https://api.github.com/users/albertfougy/repos',
		events_url: 'https://api.github.com/users/albertfougy/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/albertfougy/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'dreampoetlee',
		id: 22262765,
		node_id: 'MDQ6VXNlcjIyMjYyNzY1',
		avatar_url: 'https://avatars3.githubusercontent.com/u/22262765?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/dreampoetlee',
		html_url: 'https://github.com/dreampoetlee',
		followers_url: 'https://api.github.com/users/dreampoetlee/followers',
		following_url:
			'https://api.github.com/users/dreampoetlee/following{/other_user}',
		gists_url: 'https://api.github.com/users/dreampoetlee/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/dreampoetlee/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/dreampoetlee/subscriptions',
		organizations_url: 'https://api.github.com/users/dreampoetlee/orgs',
		repos_url: 'https://api.github.com/users/dreampoetlee/repos',
		events_url: 'https://api.github.com/users/dreampoetlee/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/dreampoetlee/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'ryanwaite28',
		id: 12706937,
		node_id: 'MDQ6VXNlcjEyNzA2OTM3',
		avatar_url: 'https://avatars1.githubusercontent.com/u/12706937?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/ryanwaite28',
		html_url: 'https://github.com/ryanwaite28',
		followers_url: 'https://api.github.com/users/ryanwaite28/followers',
		following_url:
			'https://api.github.com/users/ryanwaite28/following{/other_user}',
		gists_url: 'https://api.github.com/users/ryanwaite28/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/ryanwaite28/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/ryanwaite28/subscriptions',
		organizations_url: 'https://api.github.com/users/ryanwaite28/orgs',
		repos_url: 'https://api.github.com/users/ryanwaite28/repos',
		events_url: 'https://api.github.com/users/ryanwaite28/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/ryanwaite28/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'CharlesStover',
		id: 343837,
		node_id: 'MDQ6VXNlcjM0MzgzNw==',
		avatar_url: 'https://avatars2.githubusercontent.com/u/343837?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/CharlesStover',
		html_url: 'https://github.com/CharlesStover',
		followers_url: 'https://api.github.com/users/CharlesStover/followers',
		following_url:
			'https://api.github.com/users/CharlesStover/following{/other_user}',
		gists_url: 'https://api.github.com/users/CharlesStover/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/CharlesStover/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/CharlesStover/subscriptions',
		organizations_url: 'https://api.github.com/users/CharlesStover/orgs',
		repos_url: 'https://api.github.com/users/CharlesStover/repos',
		events_url: 'https://api.github.com/users/CharlesStover/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/CharlesStover/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'fadynabil10',
		id: 35051247,
		node_id: 'MDQ6VXNlcjM1MDUxMjQ3',
		avatar_url: 'https://avatars0.githubusercontent.com/u/35051247?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/fadynabil10',
		html_url: 'https://github.com/fadynabil10',
		followers_url: 'https://api.github.com/users/fadynabil10/followers',
		following_url:
			'https://api.github.com/users/fadynabil10/following{/other_user}',
		gists_url: 'https://api.github.com/users/fadynabil10/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/fadynabil10/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/fadynabil10/subscriptions',
		organizations_url: 'https://api.github.com/users/fadynabil10/orgs',
		repos_url: 'https://api.github.com/users/fadynabil10/repos',
		events_url: 'https://api.github.com/users/fadynabil10/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/fadynabil10/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'amit5423',
		id: 14821787,
		node_id: 'MDQ6VXNlcjE0ODIxNzg3',
		avatar_url: 'https://avatars2.githubusercontent.com/u/14821787?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/amit5423',
		html_url: 'https://github.com/amit5423',
		followers_url: 'https://api.github.com/users/amit5423/followers',
		following_url:
			'https://api.github.com/users/amit5423/following{/other_user}',
		gists_url: 'https://api.github.com/users/amit5423/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/amit5423/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/amit5423/subscriptions',
		organizations_url: 'https://api.github.com/users/amit5423/orgs',
		repos_url: 'https://api.github.com/users/amit5423/repos',
		events_url: 'https://api.github.com/users/amit5423/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/amit5423/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'abdulaziz107r',
		id: 49599681,
		node_id: 'MDQ6VXNlcjQ5NTk5Njgx',
		avatar_url: 'https://avatars1.githubusercontent.com/u/49599681?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/abdulaziz107r',
		html_url: 'https://github.com/abdulaziz107r',
		followers_url: 'https://api.github.com/users/abdulaziz107r/followers',
		following_url:
			'https://api.github.com/users/abdulaziz107r/following{/other_user}',
		gists_url: 'https://api.github.com/users/abdulaziz107r/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/abdulaziz107r/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/abdulaziz107r/subscriptions',
		organizations_url: 'https://api.github.com/users/abdulaziz107r/orgs',
		repos_url: 'https://api.github.com/users/abdulaziz107r/repos',
		events_url: 'https://api.github.com/users/abdulaziz107r/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/abdulaziz107r/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'Cynth42',
		id: 14208716,
		node_id: 'MDQ6VXNlcjE0MjA4NzE2',
		avatar_url: 'https://avatars2.githubusercontent.com/u/14208716?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/Cynth42',
		html_url: 'https://github.com/Cynth42',
		followers_url: 'https://api.github.com/users/Cynth42/followers',
		following_url:
			'https://api.github.com/users/Cynth42/following{/other_user}',
		gists_url: 'https://api.github.com/users/Cynth42/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/Cynth42/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/Cynth42/subscriptions',
		organizations_url: 'https://api.github.com/users/Cynth42/orgs',
		repos_url: 'https://api.github.com/users/Cynth42/repos',
		events_url: 'https://api.github.com/users/Cynth42/events{/privacy}',
		received_events_url: 'https://api.github.com/users/Cynth42/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'easyrun32',
		id: 38576697,
		node_id: 'MDQ6VXNlcjM4NTc2Njk3',
		avatar_url: 'https://avatars1.githubusercontent.com/u/38576697?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/easyrun32',
		html_url: 'https://github.com/easyrun32',
		followers_url: 'https://api.github.com/users/easyrun32/followers',
		following_url:
			'https://api.github.com/users/easyrun32/following{/other_user}',
		gists_url: 'https://api.github.com/users/easyrun32/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/easyrun32/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/easyrun32/subscriptions',
		organizations_url: 'https://api.github.com/users/easyrun32/orgs',
		repos_url: 'https://api.github.com/users/easyrun32/repos',
		events_url: 'https://api.github.com/users/easyrun32/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/easyrun32/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'Jesuita',
		id: 10678046,
		node_id: 'MDQ6VXNlcjEwNjc4MDQ2',
		avatar_url: 'https://avatars2.githubusercontent.com/u/10678046?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/Jesuita',
		html_url: 'https://github.com/Jesuita',
		followers_url: 'https://api.github.com/users/Jesuita/followers',
		following_url:
			'https://api.github.com/users/Jesuita/following{/other_user}',
		gists_url: 'https://api.github.com/users/Jesuita/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/Jesuita/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/Jesuita/subscriptions',
		organizations_url: 'https://api.github.com/users/Jesuita/orgs',
		repos_url: 'https://api.github.com/users/Jesuita/repos',
		events_url: 'https://api.github.com/users/Jesuita/events{/privacy}',
		received_events_url: 'https://api.github.com/users/Jesuita/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'HesterSchoeman',
		id: 51858356,
		node_id: 'MDQ6VXNlcjUxODU4MzU2',
		avatar_url: 'https://avatars0.githubusercontent.com/u/51858356?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/HesterSchoeman',
		html_url: 'https://github.com/HesterSchoeman',
		followers_url: 'https://api.github.com/users/HesterSchoeman/followers',
		following_url:
			'https://api.github.com/users/HesterSchoeman/following{/other_user}',
		gists_url: 'https://api.github.com/users/HesterSchoeman/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/HesterSchoeman/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/HesterSchoeman/subscriptions',
		organizations_url: 'https://api.github.com/users/HesterSchoeman/orgs',
		repos_url: 'https://api.github.com/users/HesterSchoeman/repos',
		events_url: 'https://api.github.com/users/HesterSchoeman/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/HesterSchoeman/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'xiyau',
		id: 34277561,
		node_id: 'MDQ6VXNlcjM0Mjc3NTYx',
		avatar_url: 'https://avatars1.githubusercontent.com/u/34277561?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/xiyau',
		html_url: 'https://github.com/xiyau',
		followers_url: 'https://api.github.com/users/xiyau/followers',
		following_url: 'https://api.github.com/users/xiyau/following{/other_user}',
		gists_url: 'https://api.github.com/users/xiyau/gists{/gist_id}',
		starred_url: 'https://api.github.com/users/xiyau/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/xiyau/subscriptions',
		organizations_url: 'https://api.github.com/users/xiyau/orgs',
		repos_url: 'https://api.github.com/users/xiyau/repos',
		events_url: 'https://api.github.com/users/xiyau/events{/privacy}',
		received_events_url: 'https://api.github.com/users/xiyau/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'code-plus-coffee',
		id: 44864604,
		node_id: 'MDQ6VXNlcjQ0ODY0NjA0',
		avatar_url: 'https://avatars3.githubusercontent.com/u/44864604?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/code-plus-coffee',
		html_url: 'https://github.com/code-plus-coffee',
		followers_url: 'https://api.github.com/users/code-plus-coffee/followers',
		following_url:
			'https://api.github.com/users/code-plus-coffee/following{/other_user}',
		gists_url: 'https://api.github.com/users/code-plus-coffee/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/code-plus-coffee/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/code-plus-coffee/subscriptions',
		organizations_url: 'https://api.github.com/users/code-plus-coffee/orgs',
		repos_url: 'https://api.github.com/users/code-plus-coffee/repos',
		events_url:
			'https://api.github.com/users/code-plus-coffee/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/code-plus-coffee/received_events',
		type: 'User',
		site_admin: false,
	},
]
